import styled from "styled-components";

export const LogOutStyle = styled.button`
  width: 100%;
  cursor: pointer;
  text-align: center;
  outline: none;
  border: none;
  background: transparent;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0;

  svg {
    width: 30px;
    height: auto;
    color: var(--grey-2);
  }

  p {
    margin: 0;
    font-size: 12px;
    line-height: 1.2;
    color: var(--grey-2);
  }

  @media (max-width: 768px) {
    svg {
      width: 30px;
    }

    p {
      font-size: 12px;
      line-height: 1.2;
    }
  }
`;
